import { MainPage } from 'components/templates/MainPage'
import { CompanyList } from 'components/molecules/CompanyList'
/**
 *
 * @returns
 */
export const CompanyListPage = (): JSX.Element => {
  return (
    <MainPage>
      <div
        className={
          'rounded-lg bg-white p-6 shadow-[0_2px_4px_rgba(0,0,0,0.08)]'
        }
      >
        <CompanyList />
      </div>
    </MainPage>
  )
}
